<template>
  <div class="menu-group flex-column">
    <ul
      v-for="index in length"
      :key="index"
      class="hide-shimmer-text rounded p16"
    >
      <div class="d-flex jcsb align-items-center flex-column">
        <ul
          v-for="index in length"
          :key="index"
          class="rounded d-flex justify-content-between w100 mb8 border-around p5 br8"
        >
          <div class="hide-shimmer-text shimmer-container rounded width10">
            random
          </div>
          <div class="hide-shimmer-text shimmer-container rounded width60">
            random tip title text
          </div>
          <div class="hide-shimmer-text shimmer-container rounded width10">
            random
          </div>
        </ul>
      </div>
    </ul>
  </div>
</template>
<script>
export default {
  name: "ShimmerProfileDrawerModal",
  components: {},
  props: {},
  data() {
    return {
      length: 3,
    };
  },
  mounted() {},
  updated() {},
  methods: {},
  computed: {},
};
</script>
